import { environment } from 'src/environments/environment';
import {
  Component,
  Input,
  ViewChild,
  OnInit,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import { Tab } from './tab.model';

@Component({
  selector: 'app-tab-content',
  template: `<iframe #iframe content-container></iframe>`
})
export class TabContentComponent implements OnInit, AfterViewInit {
  @ViewChild('iframe') iframe: ElementRef;
  @Input() tab;
  doc: any;

  ngOnInit() {}
  ngAfterViewInit() {
    const tab: Tab = this.tab;  
    this.iframe.nativeElement.setAttribute('src', environment.apiUrlFe + tab.router);
  }
}
